import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim',
  standalone: true
})
export class TrimPipe implements PipeTransform {
  transform(text: string, length: number) {

    if (length === -1) {
      return text;
    }

    if (text && text.length < length) {
      return text;
    }

    text = text
      ? text.replace(/<[^>]*>/g, '').substr(0, length) + '...'
      : '';

    return text;
  }
}


